/* eslint-disable react/no-unescaped-entities */

import { Link } from "react-router-dom";
import testimonial10 from "../../assets/images/all-img/testimonial10.png";
import testimonial11 from "../../assets/images/all-img/testimonial11.png";
import testimonial12 from "../../assets/images/all-img/testimonial12.png";
import testimonial4 from "../../assets/images/all-img/testimonial4.png";
import testimonial5 from "../../assets/images/all-img/testimonial5.png";
import testimonial6 from "../../assets/images/all-img/testimonial6.png";
import testimonial7 from "../../assets/images/all-img/testimonial7.png";
import testimonial8 from "../../assets/images/all-img/testimonial8.png";
import testimonial9 from "../../assets/images/all-img/testimonial9.png";
import star4 from "../../assets/images/svg/star4.svg";

export default function TestimonialSection() {
	return (
		<div className="section fugu-section-padding">
			<div className="container">
				<div className="fugu-section-title">
					<h2>
						Trusted by 1600k+
						<br /> people worldwide
					</h2>
				</div>
				<div className="row">
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay="0s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“I found Fugu very professional and trustworthy during my crypto trading duration of 147
								days. They are very honest and trusted.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial4} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Karen Lynn</h5>
									<span>Founder @ Company</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".10s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“100% Trusted. Very legit in crypto world. So far I'm satisfied with Nexto. I just wish
								this will continue at this way and there will be no sudden changes.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial5} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Subash Rajendran</h5>
									<span>Software engineer</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".20s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“The best place to start your trading path, thank you for support. Its a safe passive
								income strategy and will be multiply over time 😍.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial6} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Milan Milenkovic</h5>
									<span>Businessman</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".30s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“Trustable ☺️ Best way to earn passive income. Everything was well explained and it was
								easy to follow their clear. Very legit in crypto world.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial7} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Francois Malan</h5>
									<span>UI/UX Designer</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".40s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“More than just satisfied.Trustable site and the owner is very friendly & calm. And it’s
								great! The 0,5-1% daily on average is the target.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial8} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Nadir Zeblah</h5>
									<span>Manager @ Company</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".50s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“Best crypto scam investigator. It took less than 24h and gave all the details about the
								scammer and guided me. My heartfull thanks 💗 ”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial9} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>- Abdul Wadud</h5>
									<span>WP Developer</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".60s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“I found Fugu very professional and trustworthy during my crypto trading duration of 147
								days. They are very honest and trusted.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial10} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>-Brooklyn Simmons</h5>
									<span>Founder @ Company</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".70s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“100% Trusted. Very legit in crypto world. So far I'm satisfied with Nexto. I just wish
								this will continue at this way and there will be no sudden changes.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial11} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>-Guy Hawkins</h5>
									<span>Software engineer</span>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6">
						<div className="fugu-testimonial-card3 wow fadeInUpX" data-wow-delay=".80s">
							<ul>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
								<li>
									<img src={star4} alt="" />
								</li>
							</ul>
							<p>
								“The best place to start your trading path, thank you for support. Its a safe passive
								income strategy and will be multiply over time 😍.”
							</p>
							<div className="fugu-testimonial-author-wrap">
								<div className="fugu-testimonial-author-thumb">
									<img src={testimonial12} alt="" />
								</div>
								<div className="fugu-testimonial-author-data3">
									<h5>-Savannah Nguyen</h5>
									<span>Businessman</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu-testimonial-btn">
					<Link to={"#"}  >
						<a className="fugu-btn small-btn">View More</a>
					</Link>
				</div>
			</div>
		</div>
	);
}
